// import React from 'react';
// import { Button } from 'react-bootstrap';

// const Error404 = () => {
//     // Determine the redirect URL based on the environment
//     const redirectUrl = window.location.hostname === 'localhost'
//         ? 'http://localhost:3001' // Redirect to localhost for development
//         : 'https://jobbox.one'; // Redirect to production URL

//     // Function to handle redirection
//     const handleRedirect = () => {
//         window.location.href = redirectUrl;
//     };
//     return (
//         <section className="bg-white py-20 dark:bg-dark-2 lg:py-[110px]">
//             <div className="container mx-auto">
//                 <div className="flex flex-wrap items-center -mx-4">
//                     <div className="w-full px-4 md:w-5/12 lg:w-6/12">
//                         <div className="text-center">
//                             <img
//                                 src="/404.jpg"
//                                 alt="404 Not Found"
//                                 className="max-w-full mx-auto"
//                             />
//                         </div>
//                     </div>
//                     <div className="w-full px-4 md:w-7/12 lg:w-6/12 xl:w-5/12">
//                         <div>
//                             <h3 className="mb-5 text-2xl font-semibold text-dark dark:text-white">
//                                 We Can't Seem to Find The Page You're Looking For.
//                             </h3>
//                             <p className="mb-8 text-base text-body-color dark:text-dark-6">
//                                 Oops! The page you are looking for does not exist. It might have
//                                 been moved or deleted.
//                             </p>
//                             <Button
//                                 onClick={handleRedirect}
//                                 className="py-3 text-base font-medium text-white transition rounded-md  px-7 hover:bg-primary"
//                             >
//                                 Go To Home
//                             </Button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };
// export default Error404

import React from "react";
import { Button } from "react-bootstrap";

const Error404 = () => {
  // Determine the redirect URL based on the environment
  const redirectUrl =
    window.location.hostname === "localhost"
      ? "http://localhost:3001" // Redirect to localhost for development
      : "https://jobbox.one"; // Redirect to production URL

  // Function to handle redirection to home
  const handleRedirect = () => {
    window.location.href = redirectUrl;
  };

  // Function to go back to the previous page
  const handleGoBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      handleRedirect();
    }
  };

  return (
    <section className="error-page container-fluid d-flex align-items-center justify-content-center min-vh-100 py-5 px-3">
      <style>{`
    .error-page {
      position: relative;
      isolation: isolate;
      overflow: hidden;
      background: #f8f6ff;
      background-image:
        radial-gradient(ellipse at 12% 12%, rgba(167, 139, 250, .22), transparent 35%),
        radial-gradient(ellipse at 90% 90%, rgba(124, 58, 237, .12), transparent 35%);
      font-family: inherit;
    }

    .error-orb {
      position: absolute;
      z-index: -1;
      width: 240px;
      height: 240px;
      border-radius: 50%;
      background: linear-gradient(135deg, #c4b5fd, #7c3aed);
      filter: blur(2px);
      opacity: .10;
      pointer-events: none;
    }

    .error-orb-one {
      top: -100px;
      left: -70px;
    }

    .error-orb-two {
      right: -100px;
      bottom: -100px;
      width: 320px;
      height: 320px;
    }

    .error-card {
      position: relative;
      max-width: 1080px;
      overflow: hidden;
      border: 1px solid rgba(255, 255, 255, .9);
      border-radius: 30px;
      background: rgba(255, 255, 255, .88);
      box-shadow:
        0 30px 90px rgba(76, 29, 149, .10),
        0 4px 16px rgba(76, 29, 149, .04);
      backdrop-filter: blur(16px);
      -webkit-backdrop-filter: blur(16px);
    }

    .error-art-panel {
      position: relative;
      display: flex;
      min-height: 390px;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border-radius: 23px;
      background: linear-gradient(145deg, #f3edff 0%, #faf8ff 55%, #e9ddff 100%);
    }

    .error-art-panel::before,
    .error-art-panel::after {
      position: absolute;
      content: "";
      border: 1px solid rgba(124, 58, 237, .12);
      border-radius: 50%;
      pointer-events: none;
    }

    .error-art-panel::before {
      width: 290px;
      height: 290px;
    }

    .error-art-panel::after {
      width: 350px;
      height: 350px;
    }

    .error-image {
      position: relative;
      z-index: 1;
      display: block;
      width: 90%;
      max-width: 390px;
      max-height: 360px;
      object-fit: contain;
      animation: errorDrift 5s ease-in-out infinite;
      filter: drop-shadow(0 16px 18px rgba(76, 29, 149, .08));
    }

    .error-art-label {
      position: absolute;
      z-index: 2;
      right: 20px;
      bottom: 20px;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 10px 15px;
      border: 1px solid rgba(255, 255, 255, .8);
      border-radius: 30px;
      background: rgba(255, 255, 255, .85);
      color: #6d28d9;
      font-size: 12px;
      font-weight: 700;
      box-shadow: 0 8px 24px rgba(76, 29, 149, .08);
    }

    .error-art-label span {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #8b5cf6;
      box-shadow: 0 0 0 4px #ede5ff;
    }

    .error-content {
      padding: 20px 28px 20px 12px;
    }

    .error-code {
      display: inline-flex;
      align-items: center;
      gap: 9px;
      padding: 9px 14px;
      border: 1px solid #e7ddff;
      border-radius: 30px;
      background: #f5f0ff;
      color: #6d28d9;
      font-size: 12px;
      font-weight: 800;
      letter-spacing: 1px;
      text-transform: uppercase;
    }

    .error-code-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #8b5cf6;
      box-shadow: 0 0 0 4px #e9dfff;
    }

    .error-heading {
      margin: 23px 0 17px;
      color: #211632;
      font-size: clamp(35px, 4.2vw, 51px);
      font-weight: 800;
      line-height: 1.12;
      letter-spacing: -1.8px;
    }

    .error-heading-accent {
      display: block;
      color: #7c3aed;
    }

    .error-description {
      max-width: 410px;
      margin-bottom: 28px;
      color: #777084;
      font-size: 15px;
      line-height: 1.9;
    }

    .error-actions {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 12px;
    }

    .error-home-button,
    .error-back-button {
      min-height: 50px;
      padding: 0 21px !important;
      border-radius: 13px !important;
      font-size: 14px !important;
      font-weight: 700 !important;
      transition: transform .22s ease, box-shadow .22s ease, background .22s ease !important;
    }

    .error-home-button {
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
      gap: 13px;
      border: 1px solid #6d28d9 !important;
      background: linear-gradient(135deg, #8b5cf6, #6d28d9) !important;
      color: #fff !important;
      box-shadow: 0 9px 22px rgba(109, 40, 217, .23);
    }

    .error-home-button:hover {
      border-color: #5b21b6 !important;
      background: linear-gradient(135deg, #7c3aed, #5b21b6) !important;
      color: #fff !important;
      box-shadow: 0 13px 28px rgba(109, 40, 217, .30);
      transform: translateY(-3px);
    }

    .error-button-arrow {
      font-size: 20px;
      line-height: 1;
      transition: transform .22s ease;
    }

    .error-home-button:hover .error-button-arrow {
      transform: translateX(4px);
    }

    .error-back-button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 9px;
      border: 1px solid #e7e0f0 !important;
      background: #fff !important;
      color: #59456f !important;
    }

    .error-back-button:hover {
      border-color: #c4b5fd !important;
      background: #f7f3ff !important;
      color: #6d28d9 !important;
      transform: translateY(-3px);
    }

    .error-divider {
      height: 1px;
      margin: 30px 0 18px;
      background: linear-gradient(90deg, #e9ddff, transparent);
    }

    .error-footer {
      display: flex;
      align-items: center;
      gap: 9px;
      color: #9690a3;
      font-size: 11px;
      line-height: 1.6;
    }

    .error-footer-icon {
      display: inline-flex;
      width: 25px;
      height: 25px;
      flex: 0 0 25px;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      background: #f2ebff;
      color: #7c3aed;
      font-size: 14px;
    }

    @keyframes errorDrift {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-9px); }
    }

    @media (max-width: 767.98px) {
      .error-page {
        padding-top: 28px !important;
        padding-bottom: 28px !important;
      }

      .error-card {
        max-width: 520px;
        border-radius: 23px;
      }

      .error-art-panel {
        min-height: 270px;
        border-radius: 17px;
      }

      .error-art-panel::before {
        width: 210px;
        height: 210px;
      }

      .error-art-panel::after {
        width: 260px;
        height: 260px;
      }

      .error-image {
        max-width: 290px;
        max-height: 260px;
      }

      .error-content {
        padding: 12px 8px 8px;
        text-align: center;
      }

      .error-heading {
        margin-top: 19px;
        font-size: clamp(32px, 7vw, 40px);
        letter-spacing: -1px;
      }

      .error-description {
        margin-right: auto;
        margin-left: auto;
        font-size: 14px;
      }

      .error-actions {
        justify-content: center;
      }

      .error-divider {
        background: linear-gradient(90deg, transparent, #e9ddff, transparent);
      }

      .error-footer {
        justify-content: center;
      }
    }

    @media (max-width: 420px) {
      .error-card {
        padding: 16px !important;
      }

      .error-art-panel {
        min-height: 225px;
      }

      .error-image {
        max-width: 240px;
      }

      .error-actions {
        flex-direction: column;
        align-items: stretch;
      }

      .error-home-button,
      .error-back-button {
        width: 100%;
      }

      .error-heading {
        font-size: 31px;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .error-image {
        animation: none;
      }

      .error-home-button,
      .error-back-button,
      .error-button-arrow {
        transition: none !important;
      }
    }
  `}</style>

      <div className="error-orb error-orb-one"></div>
      <div className="error-orb error-orb-two"></div>

      <div className="error-card row align-items-center g-4 g-lg-5 p-3 p-md-4 p-lg-5 mx-auto w-100">
        <div className="col-12 col-md-6">
          <div className="error-art-panel">
            <img
              src="/404.jpg"
              alt="404 Page Not Found"
              className="error-image"
            />

            <div className="error-art-label">
              <span></span>
              Page not found
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6">
          <div className="error-content">
            <span className="error-code">
              <span className="error-code-dot"></span>
              Error 404
            </span>

            <h1 className="error-heading">
              Oops! You're
              <span className="error-heading-accent">off the map.</span>
            </h1>

            <p className="error-description">
              Looks like this page has wandered off. The link may be broken, or
              the page may have been moved to a new location. Let's get you back
              to where you need to be.
            </p>

            <div className="error-actions">
              <Button
                onClick={handleRedirect}
                className="error-home-button btn"
              >
                Back to Home
                <span className="error-button-arrow">→</span>
              </Button>

              <button
                onClick={handleGoBack}
                type="button"
                className="error-back-button btn"
              >
                <span>←</span>
                Go Back
              </button>
            </div>

            <div className="error-divider"></div>

            <div className="error-footer">
              <span className="error-footer-icon">✦</span>
              <span>No worries — let's get you back on track.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Error404;
